/** @jsxImportSource theme-ui */
import React from "react";
import menu from "../../data/garden/menu.yml";
import { HeaderV2 } from "../../components";

const Header = () => {
  return (
    <HeaderV2
      region="IN"
      menuItems={menu}
      isMenuRequired={false}
    />
  );
};

export default Header;
